import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  peopleSelector,
  peopleEditSelector,
  peopleSavingSelector,
  peopleLoadingSelector,

  editPeople,
  addPerson,
  removePerson,
  updatePerson,
  cancelEditPeople,
  savePeople,
} from '../../../reducers';

import ManagePeople from './component';

const mapStateToProps = (state) => {
  return {
    // use raw people selector, because the people data managed directly
    people: peopleSelector(state) || {},
    peopleEdit: peopleEditSelector(state),
    saving: peopleSavingSelector(state) ? true : false,
    loading: peopleLoadingSelector(state) ? true : false,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    editPeople,
    addPerson,
    removePerson,
    updatePerson,
    cancelEditPeople,
    savePeople,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagePeople);



// WEBPACK FOOTER //
// ./src/component/organisms/ManagePeople/index.js